// extracted by mini-css-extract-plugin
export default {"container":"Header_container__20MO2","title":"Header_title__mKFXk","subtitle":"Header_subtitle__Bc3Q4"};